import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './views/Admin/Admin.scss';

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>

const Map = React.lazy(() => import('./views/Map'));

class App extends Component {
  render() {
    const {dispatch} = this.props.store;

    return (
      <HashRouter>
        <React.Suspense fallback={loading()}>
          <Switch>
            <Route exact path="/" name="Map Routes" render={props => <Map {...props} dispatch={dispatch} />}/>
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;